module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_3016.030bd8fb.png";